<template>
  <div id="app" :style="'height:'+height+ 'px;'">
    <a id="goToTop"></a>
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      height: 0,
    }
  },
  mounted() {
    this.getHeight()
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      document.querySelector("#goToTop").scrollIntoView(true);
    },
  },
  methods: {
    getHeight() {
      // this.height = document.documentElement.clientHeight;
      var heightNum = 0
      heightNum = document.documentElement.clientHeight;
      if(heightNum*1 < 920*1) {
        this.height = 920
      }else{
        this.height = document.documentElement.clientHeight;
      }
    },
  }
}
</script>

<style>
#app {
  width: 100%;
  /*min-width: 920px;*/
  min-width: 1520px;
  min-height: 1080px;
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/App.vue